import api from './api';
import { Promotion, PromotionRequest } from '../types/promotion.types';

export const promotionService = {
    getAllPromotions: async (): Promise<Promotion[]> => {
        const response = await api.get<Promotion[]>('/promotions');
        return response.data;
    },

    getActivePromotions: async (): Promise<Promotion[]> => {
        const response = await api.get<Promotion[]>('/promotions/active');
        return response.data;
    },

    createPromotion: async (request: PromotionRequest): Promise<Promotion> => {
        const response = await api.post<Promotion>('/promotions', request);
        return response.data;
    },

    updatePromotion: async (id: number, request: PromotionRequest): Promise<Promotion> => {
        const response = await api.put<Promotion>(`/promotions/${id}`, request);
        return response.data;
    },

    deletePromotion: async (id: number): Promise<void> => {
        await api.delete(`/promotions/${id}`);
    }
};
